export default __webpack_public_path__ + "static/media/requested.0d0927b1.png";